var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"tinymce-box"},[_c('editor',{key:_vm.tinymceFlag,attrs:{"init":_vm.init,"disabled":_vm.disabled},on:{"onClick":_vm.onClick},model:{value:(_vm.myValue),callback:function ($$v) {_vm.myValue=$$v},expression:"myValue"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }